var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_58",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "40.238 88.651 48.792 88.651 59.18 88.651" },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "49.819 88.655 49.819 88.645 49.819 80.575" },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "59.406 88.649 50.852 88.649 40.465 88.649" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m55.749,72.195c-1.77.63-3.26,1.78-4.3,3.25-1.03,1.46-1.63,3.24-1.63,5.13,0-1.89-.59-3.67-1.63-5.13-1.03-1.47-2.51-2.62-4.29-3.25-5.18-1.83-8.16-7.25-6.94-12.61l2.3-10.5c.92-4.22,1.26-8.54,1.01-12.85l-.97-16.73c-.03-.57.42-1.06,1-1.06h19.05c.57,0,1.03.49.99,1.06l-.97,16.73c-.25,4.31.09,8.63,1.02,12.85l2.29,10.5c1.23,5.35-1.75,10.78-6.93,12.61Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "49.819", y1: "88.645", x2: "49.819", y2: "80.575" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m39.95,30.654l1.996.738c2.823,1.044,5.98.617,8.425-1.139h0c2.302-1.654,5.246-2.135,7.955-1.298l1.081.334",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }